import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// import AboutView from '../views/AboutView.vue'//正常加载
import LayOut from '../views/LayOut.vue'
import store from '../store/index.js'
import { getCurrentUserApi } from '@/util/request'
//哈希路由带#和正常路由
const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/look",
    name: "main",
    component: () => import("../views/main.vue"),
  },
  {
    path: '/',  //路由地址
    name: 'layout', //路由名字
    component: LayOut,//路由页面
    redirect: "/welcome",//重定向
    children: [
      {
        path: "/welcome",
        name: "welcome",
        component: () => import("../views/pages/welcome.vue")
      },
      {
        path: "/roles",
        name: "roles",
        component: () => import("../views/pages/rolesList.vue")
      },
      {
        path: "/user",
        name: "users",
        component: () => import("../views/pages/usersList.vue")
      },
      {
        path: "/project",
        name: "project",
        component: () => import("../views/pages/projectList.vue")
      },

      {
        path: "/projectStatistics",
        name: "projectStatistics",
        component: () => import("../views/pages/project/projectStatistics.vue")
      },
      {
        path: "/addProject",
        name: "addProject",
        component: () => import("../views/pages/project/addProject.vue")
      },
      {
        path: "/devProject",
        name: "devProject",
        component: () => import("../views/pages/devProjectList.vue")
      },
      {
        path: "/approval",
        name: "approval",
        component: () => import("../views/pages/approval.vue")
      },
      {
        path: "/department",
        name: "department",
        component: () => import("../views/pages/departmentList.vue")
      },
      {
        path: "/serverLogs",
        name: "serverLogs",
        component: () => import("../views/pages/ServerLogs.vue"),
        meta: { requiresAdmin: true }
      },
      {
        path: "/workRecord",
        name: "workRecord",
        component: () => import("../views/pages/workRecord.vue")
      },
      {
        path: "/weeklyReport",
        name: "weeklyReport",
        component: () => import("../views/pages/weeklyReport.vue")
      },
      {
        path: "/markdown",
        name: "markdown",
        component: () => import("../views/pages/markdown/Markdown.vue")
      },
      {
        path: "/onlineOffice",
        name: "onlineOffice",
        component: () => import("../views/pages/onlineOffice/OnlineOffice.vue")
      },
      {
        path: "/onlineDoc",
        name: "onlineDoc",
        redirect: to => ({ path: "/onlineOffice", query: { ...to.query, type: "doc" } })
      },
      {
        path: "/onlineSheet",
        name: "onlineSheet",
        redirect: to => ({ path: "/onlineOffice", query: { ...to.query, type: "sheet" } })
      },
      {
        path: "/onlineDrawio",
        name: "onlineDrawio",
        component: () => import("../views/pages/onlineDrawio/OnlineDrawio.vue")
      }

    ]
  }
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: AboutView
  // },
  // {
  //   path: '/index',
  //   name: 'LayOut',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/LayOut.vue')//懒加载模式，页面面多，可以提高性能
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
//路由守卫
router.beforeEach(async (to, form, next) => {
  /**
   * to 从哪个页面
   * form 到哪个页面
   * next 只有执行next（） 页面才会进行跳转
   */
  // 彻底禁用已隐藏菜单的直达路由（周报、文档汇总、在线流程图）
  const disabledPaths = ["/weeklyReport", "/markdown", "/onlineDrawio"]
  if (disabledPaths.includes(to.path)) {
    next("/welcome")
    return
  }
  // 静默登录：小程序 web-view 携带 token 进入（#/onlineOffice?token=xxx&embed=1），免手动登录
  const urlToken = to.query && to.query.token
  if (urlToken) {
    const cleanQuery = { ...to.query }
    delete cleanQuery.token
    const logged = store.state.userInfo.userInfo
    if (logged && logged.token === urlToken) {
      // 已登录且 token 一致，仅清理 URL 中的 token 避免泄露
      next({ path: to.path, query: cleanQuery, replace: true })
      return
    }
    try {
      sessionStorage.setItem("silent_token", urlToken)
      const user = await getCurrentUserApi()
      if (user) {
        sessionStorage.removeItem("silent_token")
        const full = { token: urlToken, user }
        store.commit('userInfo/setUserInfo', full)
        localStorage.setItem("userInfo", JSON.stringify(full))
        next({ path: to.path, query: cleanQuery, replace: true })
        return
      }
      sessionStorage.removeItem("silent_token")
    } catch (e) {
      console.error("静默登录失败", e)
      sessionStorage.removeItem("silent_token")
    }
    // 静默登录失败则走正常登录流程
    next("/login")
    return
  }
  //判断用户是否登录 //
  console.log("11111", store.state.userInfo.userInfo)
  if (!store.state.userInfo.userInfo) {
    //未登录
    if (to.path === "/login") {
      next()
      return
    }
    next("/login")
  } else {
    if (to.meta && to.meta.requiresAdmin) {
      const user = store.state.userInfo.userInfo && store.state.userInfo.userInfo.user
      if (!user || Number(user.roleId) !== 1) {
        next("/welcome")
        return
      }
    }
    next()
  }

})

export default router
